<template>
  <div
      :style="`width:${size}; height:${size}; border-left-width:2px!important;`"
      :class="`bd-l-${color}`"
      class="SPINNER x-spin" />
</template>

<script>
export default {
  name: 'spinner',
  props: {
    size: {
      type: String,
      default: '30px',
    },
    color: {
      type: String,
      default: 'depot',
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .SPINNER,
  .SPINNER:after {
    border-radius: 50%;
  }
  .SPINNER {
    border: 2px solid rgba(255, 255, 255, 0.2);
    transform: translateZ(0);
    z-index: 99999;
  }
</style>
